import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, ArrowLeft } from 'lucide-react';
import { RegenScoreRing } from '@/components/RegenScoreRing';

export default function Preview() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex flex-col px-6 pt-12 pb-10 max-w-2xl mx-auto">
      <button data-testid="back-btn" onClick={() => nav(-1)} className="text-muted-foreground hover:text-foreground inline-flex items-center gap-2 text-sm"><ArrowLeft className="w-4 h-4" /> Back</button>

      <div className="mt-8">
        <div className="label-mini text-[#00C8FF]">The YourReGen Score</div>
        <h1 className="font-display font-black text-[40px] md:text-5xl leading-[1.05] mt-3 tracking-tight">
          Consistency
          <br /><span className="text-[#00C8FF]">Creates Results.</span>
        </h1>
        <p className="text-muted-foreground mt-4 leading-relaxed">
          The YourReGen Score measures your consistency across Training, Nutrition and Recovery.
        </p>
      </div>

      <div className="mt-8 flex justify-center">
        <div className="regen-card-elevated p-8 inline-flex flex-col items-center blueprint-grid">
          <RegenScoreRing score={82} level="Elite" />
          <div className="mt-6 grid grid-cols-3 gap-4 w-full text-center">
            <div>
              <div className="label-mini text-[#00C8FF]">Training</div>
              <div className="font-mono text-xl mt-1 text-[#00C8FF]">40%</div>
              <div className="mt-2 h-1 bg-[#00C8FF]/20 rounded-full overflow-hidden">
                <div className="h-full bg-[#00C8FF] shadow-[0_0_8px_#00C8FF]" style={{ width: '100%' }} />
              </div>
            </div>
            <div>
              <div className="label-mini text-[#FFB800]">Nutrition</div>
              <div className="font-mono text-xl mt-1 text-[#FFB800]">40%</div>
              <div className="mt-2 h-1 bg-[#FFB800]/20 rounded-full overflow-hidden">
                <div className="h-full bg-[#FFB800] shadow-[0_0_8px_#FFB800]" style={{ width: '100%' }} />
              </div>
            </div>
            <div>
              <div className="label-mini text-[#7DD3FC]">Recovery</div>
              <div className="font-mono text-xl mt-1 text-[#7DD3FC]">20%</div>
              <div className="mt-2 h-1 bg-[#7DD3FC]/20 rounded-full overflow-hidden">
                <div className="h-full bg-[#7DD3FC] shadow-[0_0_8px_#7DD3FC]" style={{ width: '50%' }} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <p className="mt-6 text-center text-sm text-muted-foreground leading-relaxed">
        Focus on daily habits. The YourReGen Score helps you stay accountable and shows exactly where to improve.
      </p>

      <Button onClick={() => nav('/onboarding/program')} data-testid="continue-preview-btn" className="mt-auto h-14 w-full bg-[#00C8FF] hover:bg-[#00C8FF]/90 text-[#081726] font-semibold rounded-2xl">
        Choose Your Program <ArrowRight className="ml-2 w-4 h-4" />
      </Button>
    </div>
  );
}
